import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    { icon: 'ri-syringe-line', treatmentId: 'dental-implants', title: t('service.implants.title'), tag: 'Most Popular' },
    { icon: 'ri-contrast-2-line', treatmentId: 'porcelain-veneers', title: t('service.veneers.title'), tag: '' },
    { icon: 'ri-star-smile-line', treatmentId: 'smile-makeover', title: t('service.smile.title'), tag: 'Transformative' },
    { icon: 'ri-align-center', treatmentId: 'orthodontics', title: t('service.orthodontics.title'), tag: '' },
    { icon: 'ri-flashlight-line', treatmentId: 'teeth-whitening', title: t('service.whitening.title'), tag: 'Quick' },
    { icon: 'ri-heart-pulse-line', treatmentId: 'root-canal', title: t('service.root.title'), tag: '' },
    { icon: 'ri-shield-cross-line', treatmentId: 'crowns-bridges', title: t('service.crowns.title'), tag: '' },
    { icon: 'ri-building-line', treatmentId: 'all-on-4', title: t('service.allon4.title'), tag: 'Life-Changing' },
  ];

  const handleCardClick = (treatmentId: string) => {
    if (typeof window.REACT_APP_NAVIGATE === 'function') {
      window.REACT_APP_NAVIGATE(`/treatments#${treatmentId}`);
    }
  };

  return (
    <section id="services" className="py-24 md:py-36 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16 md:mb-24 flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <div>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-10 h-px bg-amber-400/50" />
              <span
                className="text-amber-400/80 text-xs font-medium tracking-[0.25em] uppercase"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                Treatments
              </span>
            </div>
            <h2
              className="text-4xl md:text-6xl font-normal text-white leading-tight"
              style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '-0.01em' }}
            >
              {t('services.title')}
            </h2>
          </div>
          <button
            onClick={() => {
              if (typeof window.REACT_APP_NAVIGATE === 'function') {
                window.REACT_APP_NAVIGATE('/treatments');
              }
            }}
            className="flex-shrink-0 flex items-center gap-2 border border-white/20 hover:border-amber-400/60 text-white/60 hover:text-amber-400 px-6 py-3 text-sm font-medium tracking-widest uppercase transition-all cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            {t('services.cta')}
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5">
          {services.map((service, index) => (
            <button
              key={index}
              onClick={() => handleCardClick(service.treatmentId)}
              className="group relative text-left p-7 md:p-10 bg-[#0a0a0a] hover:bg-[#111111] transition-all duration-400 cursor-pointer"
            >
              {service.tag && (
                <span
                  className="absolute top-5 right-5 text-[10px] font-medium text-amber-400/70 border border-amber-400/30 px-2 py-0.5 tracking-widest uppercase"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {service.tag}
                </span>
              )}
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-white/20 group-hover:text-amber-400 transition-colors duration-300`}></i>
              </div>
              <h3
                className="text-sm md:text-base font-normal text-white/70 group-hover:text-white leading-snug mb-3 transition-colors duration-300"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {service.title}
              </h3>
              <div className="flex items-center gap-1.5 text-amber-400/0 group-hover:text-amber-400/80 text-xs font-medium tracking-widest uppercase transition-all duration-300" style={{ fontFamily: "'Inter', sans-serif" }}>
                <span>Explore</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </button>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-10 pt-8 border-t border-white/5">
          <p className="text-white/30 text-sm font-light" style={{ fontFamily: "'Inter', sans-serif" }}>
            Every treatment is supervised by a qualified doctor — from first scan to final result.
          </p>
        </div>
      </div>
    </section>
  );
}
